/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { FunctionComponent } from 'react';
import moment from 'moment';
import { CreditPricing } from '@upstart/harmony/lib/legos/creditPricingType';
import { TieredAprConfig } from 'components/PricingEditor/Tiers/types';
import { DefaultRulesTableForUsedProps } from './types';
import useAprConfigModal from './useAprConfigModal';
import { HEADER_TOOLTIPS } from './constants';
import {
  limitMonetaryInput,
  getRuleHistoryEventUpdateInfoForUsed,
} from './utils';
import {
  renderHelpToolTip,
  renderPriceRuleSourceSelector,
  renderOffsetInput,
} from './componentsUtils';

export const DefaultRulesTableForUsed: FunctionComponent<DefaultRulesTableForUsedProps> = ({
  dealer,
  users,
  clientType,
  condition,
  priceRules,
  updatePriceRules,
  priceRulesRevisions,
  dealerPriceRules,
  defaultTieredAprConfig,
  setDefaultTieredAprConfig,
}) => {
  const { aprConfigModal, aprConfigButton } = useAprConfigModal({
    dealer,
    clientType,
    condition,
    aprConfig: priceRules?.defaultRule?.aprConfig,
    currentTieredAprConfig: defaultTieredAprConfig?.tieredAprConfig,
    onSaveForUsedCondition: (
      creditPricing: CreditPricing,
      tieredAprConfig: TieredAprConfig,
    ) => {
      updatePriceRules(newPriceRules => {
        if (newPriceRules?.defaultRule) {
          newPriceRules.defaultRule.aprConfig = {
            enabled: true,
          };
          newPriceRules.defaultRule.creditPricing = creditPricing;
        }
      });

      setDefaultTieredAprConfig({
        tieredAprConfig: { ...tieredAprConfig },
      });
    },
  });

  const { updatedAt, updatedBy } = getRuleHistoryEventUpdateInfoForUsed({
    clientType,
    condition,
    users,
    priceRules: dealerPriceRules?.data?.[clientType]?.[condition],
    priceRulesRevisions,
    isDefaultCarRule: true,
  });

  return (
    <div className="default-rule-table-container">
      <table className="rule-table default-rule-table">
        <thead>
          <tr>
            <th className="model-type">Type</th>
            <th>
              <div className="cell-content-center-header">
                Source Price{' '}
                {renderHelpToolTip(
                  'pricing-matrix-source-header-help-default-rule',
                  HEADER_TOOLTIPS.SOURCE,
                )}
              </div>
            </th>
            <th>
              <div className="cell-content-center-header">
                Offset{' '}
                {renderHelpToolTip(
                  'pricing-matrix-offset-header-help-default-rule',
                  HEADER_TOOLTIPS.OFFSET,
                )}
              </div>
            </th>
            <th>
              <div className="cell-content-center-header">
                Updated{' '}
                {renderHelpToolTip(
                  'pricing-matrix-updated-header-help-default-rule',
                  HEADER_TOOLTIPS.UPDATED,
                )}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="model-type">
              <h4>Default for all USED vehicles</h4>
            </td>
            <td align="center">
              <div className="cell-content-center">
                {renderPriceRuleSourceSelector(
                  priceRules.defaultRule.priceSource,
                  value =>
                    updatePriceRules(newPriceRules => {
                      newPriceRules.defaultRule.priceSource = value;
                    }),
                )}
              </div>
            </td>
            <td>
              <div className="cell-content-center">
                {renderOffsetInput(
                  priceRules.defaultRule.offsetType,
                  priceRules.defaultRule.offsetValue,
                  type =>
                    updatePriceRules(newPriceRules => {
                      newPriceRules.defaultRule.offsetType = type;
                    }),
                  offset =>
                    updatePriceRules(newPriceRules => {
                      newPriceRules.defaultRule.offsetValue = offset
                        ? limitMonetaryInput(offset)
                        : offset;
                    }),
                )}
              </div>
            </td>
            <td>
              {updatedAt ? moment(updatedAt).format('YYYY-MM-DD') : ''} <br />
              {updatedBy ?? null}
            </td>
            <td className="cell-content-right">{aprConfigButton}</td>
          </tr>
        </tbody>
      </table>
      {aprConfigModal}
    </div>
  );
};
